import CancelIcon from '@mui/icons-material/Cancel'
import { Box, Typography } from '@mui/material'

import { CenteredLoading } from '../../components'
import {
  RepairPaymentEntry,
  RepairPaymentInfoCachedFinixTransferStatusEnum
} from '../../sdk'
import SuccessContent from './SuccessContent'

interface Props {
  payment: RepairPaymentEntry
}

const PaymentCreated = ({ payment }: Props) => {
  const isLoading = payment.info?.cachedFinixTransferStatus === undefined
  const isSuccess =
    payment.info?.cachedFinixTransferStatus ===
    RepairPaymentInfoCachedFinixTransferStatusEnum.Succeeded
  const isPending =
    payment.info?.cachedFinixTransferStatus ===
    RepairPaymentInfoCachedFinixTransferStatusEnum.Pending
  const isFailed = !isLoading && !isSuccess && !isPending

  return (
    <>
      {isSuccess && <SuccessContent />}
      {isPending && <SuccessContent />}
      {isFailed && (
        <Box
          flexDirection="column"
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ height: '100%' }}>
          <Box display="flex" flexDirection="row">
            <CancelIcon color="error" sx={{ mr: 1 }} />
            <Typography variant="h3">
              Payment Failed! Please contact the shop for further assistance.
            </Typography>
          </Box>
        </Box>
      )}
      {isLoading && (
        <Box
          flexDirection="column"
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ height: '100%' }}>
          <Box display="flex" flexDirection="row">
            <CenteredLoading />
            <Typography variant="h3">Processing payment...</Typography>
          </Box>
        </Box>
      )}
    </>
  )
}

export default PaymentCreated
